import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { RuleList } from '../templatemanager.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as api from '../../../shared/api/apihandler';

@Component({
  selector: 'rule-list',
  templateUrl: './rule-list.component.html',
  styleUrls: ['./rule-list.component.css']
})
export class RuleListComponent implements OnInit {

  @Input() rule: RuleList = new RuleList();
  @Input() listId: string;
  @Output() ruleRemoved = new EventEmitter<string>();

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
  }

  removeRule(id: string) {
    let value = JSON.stringify({listId: this.listId, ruleId: id});
    this.ruleRemoved.emit(value);
  }

}
